import { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Lock, Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { API_URL } from "@/lib/links";
import { adminSession } from "@/lib/adminSession";

export const PasscodeDialog = ({ open, onClose }) => {
  const [code, setCode] = useState("");
  const [status, setStatus] = useState("idle");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const close = () => { setCode(""); setError(""); setStatus("idle"); onClose(); };

  const submit = async (e) => {
    e.preventDefault();
    setStatus("loading");
    setError("");
    try {
      const { data } = await axios.post(`${API_URL}/admin/login`, { passcode: code });
      adminSession.set(data.token);
      close();
      navigate("/admin");
    } catch (err) {
      setStatus("idle");
      setError(err.response?.status === 401 ? "Incorrect passcode" : "Something went wrong. Try again.");
    }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && close()}>
      <DialogContent className="w-[calc(100%-2rem)] max-w-sm rounded-2xl border-line bg-panel p-0 text-body [&>button]:text-muted" data-testid="passcode-dialog">
        <form onSubmit={submit} className="p-6 sm:p-8">
          <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-blue/15 text-blue-text ring-1 ring-blue/30"><Lock size={18} /></span>
          <DialogTitle className="mt-4 text-xl font-semibold tracking-tight text-body">Admin access</DialogTitle>
          <DialogDescription className="mt-1 text-sm text-muted">Enter your passcode to open the dashboard.</DialogDescription>
          <input
            className="field mt-5 text-center text-2xl tracking-[0.5em]"
            type="password"
            inputMode="numeric"
            autoFocus
            maxLength={8}
            value={code}
            onChange={(e) => setCode(e.target.value)}
            data-testid="passcode-input"
          />
          {error && <p className="mt-3 text-sm text-red-400" data-testid="passcode-error">{error}</p>}
          <button type="submit" className="btn btn-primary mt-5 w-full" disabled={status === "loading" || !code} data-testid="passcode-submit-button">
            {status === "loading" ? <Loader2 size={16} className="animate-spin" /> : null} Unlock
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
};
